import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';

import { localizeRoutes } from '../utils/routeUtils';

import EbonsPage from '../components/pages/account/myebons/EbonsPage';
import ProfilePage from '../components/pages/account/myprofile/ProfilePage';
import MessagePage from '../components/pages/account/mymessages/MessagePage';
import MyMessagesPage from '../components/pages/account/mymessages/MyMessagesPage';
import AccountPurchasePage from '../components/pages/account/cashback/AccountPurchasePage';

export const accountLocalizableRoutes = [
    {
        path: PATH.ACCOUNT_MESSAGES_PATH,
        component: MyMessagesPage,
        exact: true
    },
    {
        path: `${PATH.ACCOUNT_MESSAGES_PATH}/:id`,
        component: MessagePage
    },
    {
        path: PATH.ACCOUNT_JACKPOT_PATH,
        component: AccountPurchasePage,
        exact: true
    },
    {
        path: PATH.ACCOUNT_EBONS_PATH,
        component: EbonsPage,
        exact: true
    },
    {
        path: PATH.ACCOUNT_PROFILE_PATH,
        component: ProfilePage,
        exact: true
    }
];

export const accountRoutes = [
    ...accountLocalizableRoutes,
    ...localizeRoutes(LOCALES, accountLocalizableRoutes)
];



// WEBPACK FOOTER //
// ./src/routes/account.js